import "./Text.scss";
import React, { useEffect, useState, useContext } from "react";
import {
  Input,
  Row,
  Col
} from "antd";

import { useTranslation } from "react-i18next";
const { TextArea } = Input;

const Text = ({ component, mode, lang, handleChangeValues }) => {

    const handleChangeFieldValue = (component, value) => {
        component.value = value
        handleChangeValues && handleChangeValues(component)
    }

    const { t } = useTranslation('forms');

    return (
        <Row className="form-manager-text-form">
            { component.hasTitle &&
                <Row className="text-title">
                    {component.title && component.title[lang]}
                </Row>
            }
            { mode !== 'pdf' ?
                <>
                <TextArea rows={4} value={component.value}
                    onChange={(e) => handleChangeFieldValue(component, e.target.value)}
                    maxLength={component.maxLength+1}
                    style={{ width: "100%" }}
                    className={'field-section'+(component.required ? ' required':'')+(component.value ? ' withval':' noval')}
                />
                {component.maxLength && component.value && component.value.length > component.maxLength && (
                    <div style={{ color: 'red', fontSize: '13px', marginTop: 4 }}>
                        {t('forms.errors.maxLength', { max: component.maxLength })}
                    </div>
                )}
                </>
                :
                <pre className="text">{component.value}</pre>
            }
        </Row>
    )
}
    
export default Text;    
